import * as React from 'react';

import TypeScale from '@identity/type';
import { TextWrapper } from '@identity/wrappers';
import MarkdownRenderer from '../MarkdownRenderer';

interface Props {
  subHeading: string;
  heading: string;
  description: string;
}

const SectionText = ({ subHeading, heading, description }: Props) => (
  <TextWrapper space={{ margin: 'vertical-lg' }}>
    {subHeading && (
      <TypeScale.SMALL
        spacing={{ padding: 'bottom-xs' }}
        uppercase
        fontWeight="600"
      >
        {subHeading}
      </TypeScale.SMALL>
    )}
    {heading && (
      <TypeScale.H2 spacing={{ padding: 'bottom-xs' }} fontWeight="300">
        {heading}
      </TypeScale.H2>
    )}
    {description && <MarkdownRenderer source={description.description} />}
  </TextWrapper>
);

export default SectionText;
